import { Point } from '../types';
import { UIEvent, getPageX, getPageY, isPointerEvent } from '../../uievent';

export function getClientPoint<T extends Element>(ev: UIEvent<T>): Point {
  let clientRect;
  if (isPointerEvent(ev)) {
    clientRect = (ev.currentTarget as HTMLElement).getBoundingClientRect();
  } else {
    clientRect = ev.currentTarget.getBoundingClientRect();
  }
  return {
    x: getPageX(ev) - clientRect.left,
    y: getPageY(ev) - clientRect.top,
  };
}
